import { timestamps, uuid } from '@snap-types/models/common';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

import {
  emailConfigTypeSchema,
  quoteEmailTemplateSchema,
  quotePdfTypeSchema,
} from '../enums';

export const columns = {
  uuid,

  active: z.boolean(),
  daysUntilExpiration: z.number(),
  daysUntilExpectedWin: z.number(),
  quotePdfType: quotePdfTypeSchema,

  quoteEmailSettings: emailConfigTypeSchema,
  quoteEmailTemplate: quoteEmailTemplateSchema,
  // Enforced by Postgres itself (see TeamConfig.quoteIdPrefix's @db.VarChar(5) in
  // schema.prisma) - see the fuller comment on this field in `columnValidators` below.
  quoteIdPrefix: z.string().max(5),

  alphaEmbedTeam: z.boolean(),

  forTeamUuid: uuid,

  createdByUserUuid: z.uuid().nullish(),
  deletedAt: z.date().nullish(),
  ...timestamps,
} as const;

export const columnValidators = {
  uuid: uuid,

  active: z.boolean(),
  daysUntilExpiration: schema.t.num.fromString
    .pipe(schema.t.int.positive.min(1, { error: 'Must be 1 or more' }))
    .default(30),
  daysUntilExpectedWin: schema.t.num.fromString
    .pipe(schema.t.int.positive.min(1, { error: 'Must be 1 or more' }))
    .default(2),
  quotePdfType: quotePdfTypeSchema,
  quoteEmailSettings: emailConfigTypeSchema,
  quoteEmailTemplate: quoteEmailTemplateSchema,
  /**
   * Every quote ID is built as `${quoteIdPrefix}${SNAP_QUOTE_PREFIX}${sequence}`
   * (see @api/util/generate-id.ts) and must fit in Visual's
   * `QUOTE.ID nvarchar(15)` column (.docker/visual/setup.sql). `QQ` (the
   * fixed `SNAP_QUOTE_PREFIX`) takes 2 characters. The `id_generator`
   * Postgres sequence starts at 10000000 (see
   * prisma/migrations/20230525151028_id_sequencer/migration.sql), so it's
   * already 8 digits and will stay 8 digits for the next 90 million quotes;
   * that leaves 5 characters for the prefix. Postgres itself enforces this
   * length too (TeamConfig.quoteIdPrefix's @db.VarChar(5) in schema.prisma);
   * `.max()` here just gives a clean rejection before that.
   */
  quoteIdPrefix: z.string().nonempty().max(5),
  alphaEmbedTeam: z.boolean().default(false),
};
